import { ReportDiffState } from './ReportDiffState';
import { ReportDiffCountMap } from './ReportDiffCountMap';

export class ReportDiff {
  constructor(
    private readonly state: ReportDiffState,
    private readonly currentInstancesCountMap: ReportDiffCountMap,
    private readonly selectedInstancesCountMap: ReportDiffCountMap,
    private readonly currentIssuesCountMap: ReportDiffCountMap,
    private readonly selectedIssuesCountMap: ReportDiffCountMap
  ) {}

  getState() {
    return this.state;
  }

  getCurrentInstancesCountMap() {
    return this.currentInstancesCountMap;
  }

  getSelectedInstancesCountMap() {
    return this.selectedInstancesCountMap;
  }

  getCurrentIssuesCountMap() {
    return this.currentIssuesCountMap;
  }

  getSelectedIssuesCountMap() {
    return this.selectedIssuesCountMap;
  }

  isPending() {
    return this.state === ReportDiffState.PENDING;
  }

  isDone() {
    return this.state === ReportDiffState.DONE;
  }

  isFailed() {
    return this.state === ReportDiffState.FAILED;
  }
}
